import { TextSearch } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const HorizontalListQueryIcon = createLucideIcon(TextSearch);
